export default {
  paid: 'Paid',
  unpaid: 'Unpaid',
  no_paid: 'Not Paid',
  partially_paid: 'Partially Paid',
  partial_paid: 'Partially Paid',
  exchanged: 'Exchanged',
  exchange: 'Exchanged',
  refunded: 'Refunded',
  partially_refunded: 'Partially Refunded'
}
